import {observer} from "mobx-react"
import {PageContentTitle} from "../../ui"
import {cmsRuleDetailStore, growlStore} from "../../../store"
import {CmsRuleForm, CmsRuleFormData} from "./CmsRuleForm";

const CmsRuleDetailPage = observer(function CmsDetailPage() {
    const {
        name,
        field,
        value,
        action
    } = cmsRuleDetailStore

    const data: CmsRuleFormData = {
        name,
        field,
        value,
        action
    }

    const display = `Scan Dokument Regel: ${name}`
    const dirty = cmsRuleDetailStore.dirty
    const valid = cmsRuleDetailStore.valid

    return <>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${cmsRuleDetailStore.saving ? 'is-loading' : ''}`,
                    disabled: !(dirty && valid),
                    action: async () => {
                        await cmsRuleDetailStore.save()
                        cmsRuleDetailStore.reset()
                        growlStore.add({
                            message: 'Die Regel wurde erfolgreich gespeichert',
                            autoclose: true,
                            closable: true
                        })
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: cmsRuleDetailStore.saving || !cmsRuleDetailStore.dirty,
                    action: async () => {
                        cmsRuleDetailStore.reset()
                        await cmsRuleDetailStore.load()
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <CmsRuleForm
            mode={'update'}
            saving={cmsRuleDetailStore.saving}
            data={data}
            validate={async () => {
                await cmsRuleDetailStore.validate()
            }}
            onChange={val => {
                const {
                    name,
                    field,
                    value,
                    action
                } = val
                cmsRuleDetailStore.name = name
                cmsRuleDetailStore.field = field
                cmsRuleDetailStore.value = value
                cmsRuleDetailStore.action = action
            }}/>
    </>
})

export {
    CmsRuleDetailPage
}
